import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=6302320e&scoped=true&"
import script from "./Treatments.vue?vue&type=script&lang=js&"
export * from "./Treatments.vue?vue&type=script&lang=js&"
import style0 from "./Treatments.vue?vue&type=style&index=0&id=6302320e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6302320e",
  null
  
)

export default component.exports